import React from 'react';

export const TempusLogoSmall = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 4.88904H2.5834V2H1V4.88904V4.88904V4.88904Z" fill="#29293D" />
    <path d="M3.42505 4.88904H6.31825V2H3.42505V4.88904V4.88904V4.88904Z" fill="#29293D" />
    <path d="M7.5127 4.88904V14.3671H11.0912V4.88904H13.1426V2H7.5127V4.88904V4.88904V4.88904Z" fill="#29293D" />
    <path d="M13.9843 2V4.88904H15.1786V2H13.9843V2V2Z" fill="#29293D" />
  </svg>
);
